import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_EXP } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { UpdateExpPayload } from '../../../../resources/payload';

export const useUpdateExp = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ ...values }) => {
      const payload = UpdateExpPayload(values);
      const response = await POST(POST_UPDATE_EXP(), payload);
      return response.result;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'แก้ไขวันหมดอายุสำเร็จ' });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
  });
  return { mutate, loading: isPending };
};
